import React from 'react';
import { Link } from 'react-router-dom';
import { Rss, Calendar, Landmark, Users, MapPin, Building2, ArrowUpRight } from 'lucide-react';

const TILES = [
  { to: '/news',          icon: Rss,       label: 'News',          desc: 'Latest from Paisley',     glow: 'from-sky-400 to-blue-500' },
  { to: '/events',        icon: Calendar,  label: 'Events',        desc: "What's on this week",     glow: 'from-fuchsia-400 to-pink-500' },
  { to: '/history',       icon: Landmark,  label: 'History',       desc: 'Stories & heritage',      glow: 'from-amber-400 to-orange-500' },
  { to: '/famous-people', icon: Users,     label: 'Famous People', desc: 'Notable Paisley names',   glow: 'from-emerald-400 to-teal-500' },
  { to: '/attractions',   icon: MapPin,    label: 'Attractions',   desc: 'Plan your visit',         glow: 'from-violet-400 to-indigo-500' },
  { to: 'https://paisleyscotland.com/directory', icon: Building2, label: 'Directory', desc: 'Local businesses', glow: 'from-slate-400 to-slate-600', external: true },
];

const CategoryTiles = () => (
  <section className="relative py-24" data-testid="category-tiles">
    <div className="aurora-orb w-[420px] h-[420px] top-10 left-1/4 bg-sky-200/60" />

    <div className="relative max-w-7xl mx-auto px-6">
      <div className="mb-10">
        <p className="text-xs uppercase tracking-[0.25em] font-bold text-sky-600 mb-3">Sections</p>
        <h2 className="text-5xl md:text-6xl font-bold tracking-[-0.04em] text-slate-900 leading-none">
          Explore the <span className="font-serif-accent italic font-light bg-gradient-to-r from-sky-500 to-indigo-500 bg-clip-text text-transparent">site</span>
        </h2>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
        {TILES.map((t) => {
          const Icon = t.icon;
          const className = "group relative glass rounded-3xl p-6 md:p-7 glass-hover overflow-hidden min-h-[180px] flex flex-col justify-between";
          const inner = (
            <>
              {/* Coloured glow blob top-right */}
              <div className={`absolute -top-10 -right-10 w-32 h-32 bg-gradient-to-br ${t.glow} rounded-full opacity-20 blur-2xl group-hover:opacity-40 transition-opacity duration-500`} />
              <div className="relative flex items-center justify-between">
                <span className={`w-10 h-10 rounded-2xl bg-gradient-to-br ${t.glow} flex items-center justify-center text-white shadow-lg shadow-slate-900/10 ring-1 ring-white/40`}>
                  <Icon size={18} strokeWidth={2} />
                </span>
                <ArrowUpRight size={16} className="text-slate-400 group-hover:text-sky-600 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </div>
              <div className="relative">
                <h3 className="text-2xl md:text-3xl font-bold tracking-[-0.03em] text-slate-900">{t.label}</h3>
                <p className="text-xs font-medium text-slate-500 mt-1">{t.desc}</p>
              </div>
            </>
          );
          const testId = `category-tile-${t.label.toLowerCase().replace(' ', '-')}`;
          return t.external ? (
            <a key={t.to} href={t.to} rel="noopener noreferrer" className={className} data-testid={testId}>{inner}</a>
          ) : (
            <Link key={t.to} to={t.to} className={className} data-testid={testId}>{inner}</Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default CategoryTiles;
